import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../store'; // Adjust the path based on your store setup

const WelcomePage: React.FC = () => {
  const user = useSelector((state: RootState) => state.auth.user);

  if (!user) {
    return <p>Loading...</p>;
  }

  return (
    <div style={{ padding: '2rem' }}>
      <h1>Welcome, {user.first_name} {user.last_name}!</h1>
      <p>You are logged in as <strong>{user.username}</strong>.</p>
      <p>Your role: <strong>{user.role}</strong></p>
      <p>Email: {user.email}</p>
    </div>
  );
};

export default WelcomePage;